import { LitElement, html, css, property, customElement, CSSResultGroup } from 'lit-element';
import styles from './nile-progress-bar.css';

@customElement('nile-progress-bar')
export class NileProgressBar extends LitElement {
  static override styles: CSSResultGroup = styles;

  @property({ type: Number }) value = 0;

  override render() {
    return html`
      <div class="nile-progress-bar__container">
        ${this.value === 0 ? html`<ul class="nile-progress-bar__progress-bar nile-progress-bar__reset"></ul>` : html``}
        <ul class="nile-progress-bar__progress-bar">
          <li><span style="width: ${this.value}%"></span></li>
        </ul>
      </div>
    `;
  }
}
